"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _filterColumn = _interopRequireDefault(require("../styles/filter-column.css"));

var _filterOption = _interopRequireDefault(require("./filter-option"));

var _modelFilter = _interopRequireDefault(require("./model-filter.props/model-filter.defaultProps"));

var _modelFilter2 = require("./model-filter.props/model-filter.propTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    isEmptyArray = dataUtils.isEmptyArray;

var FilterColumn = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(FilterColumn, _React$Component);

  function FilterColumn(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var updateSelection = props.changeEvent !== null ? props.changeEvent : _this.updateSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      selectedOption: null,
      updateSelection: updateSelection
    };
    return _this;
  }

  var _proto = FilterColumn.prototype;

  _proto.updateSelection = function updateSelection(e) {
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      selectedOption: e.target.value
    }));
  };

  _proto.renderOptions = function renderOptions(filteringOptions, theme, code) {
    var _this2 = this;

    var selectedOption = this.props.selectedOption || this.state.selectedOption;
    var enabledOptions = this.props.enabledOptions || [];
    var optionKey = this.props.optionKey || '';
    return filteringOptions && filteringOptions.map(function (el, i) {
      return /*#__PURE__*/_react["default"].createElement(_filterOption["default"], {
        selectedOption: selectedOption,
        enabledOptions: enabledOptions,
        optionKey: optionKey,
        updateSelection: _this2.state.updateSelection,
        groupName: code,
        theme: theme,
        data: el,
        key: i
      });
    });
  };

  _proto.renderLabel = function renderLabel(theme, label, filters) {
    if (!isEmptyArray(filters)) {
      return /*#__PURE__*/_react["default"].createElement("h3", {
        className: _filterColumn["default"].heading + " " + theme.labelSmall + " " + theme.marginBottom10
      }, label);
    }

    return '';
  };

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        data = _this$props.data,
        index = _this$props.index;
    var label = handleNestedProp(data, 'data.label');
    var code = handleNestedProp(data, 'data.code') + "_" + index;
    var filteringOptions = handleNestedProp(data, 'data.filteringOptions');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-12']
    }, this.renderLabel(theme, label, filteringOptions), /*#__PURE__*/_react["default"].createElement("ul", {
      className: theme.row + " " + _filterColumn["default"].list + " " + theme.marginBottom20
    }, this.renderOptions(handleNestedProp(data, 'data.filteringOptions'), theme, code)));
  };

  return FilterColumn;
}(_react["default"].Component);

exports["default"] = FilterColumn;
FilterColumn.defaultProps = {
  data: _modelFilter["default"].filters[0],
  theme: {}
};